import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormFeedback,
    Input,
    Label,
    Row,
} from "reactstrap";

import Breadcrumbs from "components/Common/Breadcrumb";

import * as Yup from "yup";
import { useFormik } from "formik";
import CommonDialog from "components/Common/CommonDialog";
import ToastDialog from "components/Common/ToastDialog";

import { useToast } from "ToastStore";
import { addRegion, editRegion, getRegion } from "http/Region";
import { SystemConfigurationContext } from "context/systemConfigContext";

const AddOrEditRegion = () => {
    const [region, setRegion] = useState({})
    const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const navigate = useNavigate();
    const {inputMax} = useContext(SystemConfigurationContext)

    const urlParams = new URLSearchParams(window.location.search)
    const encodedId = urlParams.get("id")
    const decodedId = atob(encodedId)
    
    const {roleName}= JSON.parse(localStorage.getItem("user"))

    const { handleToastData } = useToast();

    document.title = encodedId ? "Edit Region | DMS" : "Add Region | DMS"

    useEffect(() => {
        if (encodedId) {
            getRegion({ regionId: decodedId })
                .then(responseFromAPI => {
                    if (responseFromAPI.status && responseFromAPI.code == 200) {
                        setRegion(responseFromAPI.data)
                    }
                })
                .catch(error => { })
        }
    }, [])
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            regionName: region.regionName || "",
        },

        validationSchema: Yup.object({
            regionName: Yup.string().required("Please Enter Region Name"),
        }),

        onSubmit: (values) => {
            const message = encodedId ? 'Are you sure want to edit region?' : 'Do you want to save entry?'
            setShowCommonDialog({ isShow: true, message })
        }
    });

    const handleCancel = () => {
        navigate(-1)
    }

    const submitPromotion = () => {
        const { values } = validation
        const regionData = {
            regionName: values.regionName,
        }
        if (encodedId) {
            regionData.regionId = decodedId
            editRegion(regionData)
                .then(responseFromAPI => {
                    if (responseFromAPI.status) {

                        handleToastData('Region updated successfully', "warning")
                        validation.resetForm()
                        navigate(`/${roleName}/listRegion`);

                    } else {
                        setToastInfo({
                            message: responseFromAPI.message,
                            showToast: true,
                            role: "error",
                        });
                    }
                })
                .catch(error => { })
        } else {
            addRegion(regionData)
                .then(responseFromAPI => {
                    if (responseFromAPI.status) {
                        handleToastData('Region updated successfully', "success")
                        validation.resetForm()
                        navigate(`/${roleName}/listRegion`);
                    } else {
                        setToastInfo({
                            message: responseFromAPI.message,
                            showToast: true,
                            role: "error",
                        });
                    }
                })
                .catch(error => { })
        }

    }

    const dialogAction = (action, data) => {
        if (action == 1) {
            setShowCommonDialog({ isShow: false })
            submitPromotion()
        } else {
            setShowCommonDialog({ isShow: false })
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="ms-2">
                <Breadcrumbs title="Region" breadcrumbItem={encodedId ? "Edit Region" : "Add Region"} />
                </div>
                <Container fluid className="vertical-scroll">
                    <Card>
                        <CardBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-4 required">Region Name</Label>
                                        <Input
                                            maxLength={inputMax}
                                            name="regionName"
                                            type="text"
                                            placeholder="Enter Region Name"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.regionName || ""}
                                            invalid={
                                                validation.touched.regionName &&
                                                validation.errors.regionName
                                            }
                                        />
                                        {validation.touched.regionName &&
                                            validation.errors.regionName ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.regionName}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>
                                </Row>
                                <Col className="mt-4">
                                    <div className="d-flex gap-3 justify-content-end">
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success save-customer"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </Col>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </div>
            {
                showCommonDialog &&
                <CommonDialog
                    isShow={showCommonDialog.isShow}
                    message={showCommonDialog.message} data={showCommonDialog.data}
                    postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}
                />
            }
            <ToastDialog
                message={toastInfo.message}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
        </React.Fragment>

    )
}

export default AddOrEditRegion